import { Modal, ModalContent } from '@/shared/components/ui/modal'

import ReportProblem from './ReportProblem'

export function CreateTicketModal({
	close: handleClose,
	isOpen,
}: {
	close(): void
	isOpen: boolean
}) {
	return (
		<Modal
			open={isOpen}
			onOpenChange={(open) => {
				if (!open) {
					handleClose()
				}
			}}
		>
			<ModalContent>
				<ReportProblem close={handleClose} />
			</ModalContent>
		</Modal>
	)
}
